'use client';

import React, { useState } from "react";
import PropTypes from "prop-types";
import GradientWrapper from "../UI/GradientWrapper";

const TextareaInput = ({
  label,
  name,
  value = "",
  onChange,
  className = "",
  error = "",
  inputClassName = "",
  labelClassName = "",
  maxLength = 999,
  variant = "default", // default | gradient
  ...props
}) => {
  const [charCount, setCharCount] = useState(value ? value.length : 0);

  const handleChange = (e) => {
    setCharCount(e.target.value.length);
    if (onChange) onChange(e);
  };

  if (variant === "gradient") {
      return (
        <div className={`w-full ${className}`}>
             {label && (
                <label 
                    htmlFor={name} 
                    className={`block text-sm text-gray-400 mb-2 ${labelClassName}`}
                >
                    {label}
                </label>
             )}
            <GradientWrapper>
                <textarea
                    id={name}
                    name={name}
                    value={value ?? ""}
                    onChange={handleChange}
                    maxLength={maxLength}
                    {...props}
                    className={`w-full px-3 py-2 bg-transparent border-none text-white focus:outline-none custom-scrollbar resize-none ${inputClassName}`}
                ></textarea>
            </GradientWrapper>
            <div className="flex justify-end items-start mt-1">
                 <span className="text-gray-500 text-xs font-thin ml-auto">
                    {charCount}/{maxLength}
                 </span>
            </div>
        </div>
      );
  }

  return (
    <div className={`relative w-full ${className}`}>
      <textarea
        id={name}
        name={name}
        value={value ?? ""}
        onChange={handleChange}
        maxLength={maxLength}
        {...props}
        className={`peer w-full bg-color-98 text-color-1 text-sm border rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-[var(--accent-dark)] hover:border-[var(--accent-dark)] shadow-sm focus:shadow ${
          error ? "border-red-500" : "border-color-50"
        } ${inputClassName}`}
      ></textarea>
      <label
        htmlFor={name}
        className={`absolute -top-2 left-2.5 bg-color-98 px-1 text-xs text-color-1 w-fit ${
          error ? "text-red-500" : ""
        } ${labelClassName}`}
      >
        {label}
      </label>
      <div className="flex justify-end items-start mt-1 px-1">
        <span className="text-color-1 text-xs font-thin ml-auto">
          {charCount}/{maxLength}
        </span>
      </div>
    </div>
  );
};

TextareaInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  error: PropTypes.string,
  maxLength: PropTypes.number,
  variant: PropTypes.oneOf(['default', 'gradient'])
};

export default TextareaInput;
